module.exports = __webpack_public_path__ + "static/media/LB.a182bef1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LB.svg
// module id = 297
// module chunks = 0